import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const currency = new AxiosInterceptor();

export default {
  getAll(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return currency.get("/currency?" + qstr);
  },
  find(id) {
    return currency.get("/currency/" + id);
  },
  create(data) {
    return currency.post("/currency", data);
  },
  update(id, data) {
    return currency.put("/currency/" + id, data);
  },
  delete(id) {
    return currency.delete("/currency/" + id);
  },
  getRate(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return currency.get("/currency-rate?" + qstr);
  },
  createRate(data) {
    return currency.post("/currency-rate", data);
  },
  deleteRate(id) {
    return currency.delete("/currency-rate/" + id);
  },
};
